export default __webpack_public_path__ + "static/media/sprite.06ce50e4.svg";